import React from 'react';
import { Route } from 'react-router-dom';

// 3PL warehouse module pages (client portal lives outside Layout — see App.tsx)
const ThreePLDashboard = React.lazy(() => import('../pages/threepl/ThreePLDashboard'));
const ThreePLClients = React.lazy(() => import('../pages/threepl/ThreePLClients'));
const ThreePLMovements = React.lazy(() => import('../pages/threepl/ThreePLMovements'));
const ThreePLApprovals = React.lazy(() => import('../pages/threepl/ThreePLApprovals'));
const ThreePLStockOnHand = React.lazy(() => import('../pages/threepl/ThreePLStockOnHand'));
const ThreePLSkuSummary = React.lazy(() => import('../pages/threepl/ThreePLSkuSummary'));
const ThreePLProducts = React.lazy(() => import('../pages/threepl/ThreePLProducts'));
const ThreePLProductDetail = React.lazy(() => import('../pages/threepl/ThreePLProductDetail'));
const ThreePLStockReconciliation = React.lazy(() => import('../pages/threepl/ThreePLStockReconciliation'));
const ThreePLInvoicing = React.lazy(() => import('../pages/threepl/ThreePLInvoicing'));
const ThreePLClientStatement = React.lazy(() => import('../pages/threepl/ThreePLClientStatement'));
const ThreePLHealthCheck = React.lazy(() => import('../pages/threepl/ThreePLHealthCheck'));

export const threeplRoutes = [
  <Route key="/3pl" path="/3pl" element={<ThreePLDashboard />} />,
  <Route key="/3pl/clients" path="/3pl/clients" element={<ThreePLClients />} />,
  <Route key="/3pl/movements" path="/3pl/movements" element={<ThreePLMovements />} />,
  <Route key="/3pl/approvals" path="/3pl/approvals" element={<ThreePLApprovals />} />,
  <Route key="/3pl/stock" path="/3pl/stock" element={<ThreePLStockOnHand />} />,
  <Route key="/3pl/sku-summary" path="/3pl/sku-summary" element={<ThreePLSkuSummary />} />,
  <Route key="/3pl/products" path="/3pl/products" element={<ThreePLProducts />} />,
  <Route key="/3pl/products/:id" path="/3pl/products/:id" element={<ThreePLProductDetail />} />,
  <Route key="/3pl/stock-count" path="/3pl/stock-count" element={<ThreePLStockReconciliation />} />,
  <Route key="/3pl/invoicing" path="/3pl/invoicing" element={<ThreePLInvoicing />} />,
  <Route key="/3pl/statement" path="/3pl/statement" element={<ThreePLClientStatement />} />,
  <Route key="/3pl/health-check" path="/3pl/health-check" element={<ThreePLHealthCheck />} />,
];
